import { render, staticRenderFns } from "./add-contact.vue?vue&type=template&id=75c01946&scoped=true&"
import script from "./add-contact.vue?vue&type=script&lang=js&"
export * from "./add-contact.vue?vue&type=script&lang=js&"
import style0 from "./add-contact.vue?vue&type=style&index=0&id=75c01946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c01946",
  null
  
)

export default component.exports